import React, { Component } from 'react'
import {FormattedMessage, injectIntl} from 'react-intl'
import PropTypes from 'prop-types'
import {Table, Data } from 'components/layout/Table'
import { messages as messagesLayout } from 'constants/layout'
import { FormattedDate } from '../../../intl'
import { Button } from '../../../misc'
import { Modal } from '../../../../containers/misc'
import ViewMessage from '../ViewMessage/ViewMessage'
import RecipientsTable from '../RecipientsTable/RecipientsTable'
import { get } from 'lodash'
import config from 'config'
import { Link } from 'react-router-dom'


@injectIntl
export default class MessagesTable extends Component {
  static propTypes = {
    messages: PropTypes.object.isRequired,
    permissions: PropTypes.object.isRequired,
    setCommonLimit: PropTypes.func,
    intl: PropTypes.object.isRequired
  }

  static defaultProps = {
    permissions: {}
  }

  state = {
    message: null,
    recipients: []
  }

  handleViewMessage = message => {
    this.setState(
        {
          message
        },
        () => {
          this.props.modal(`modal-view-message-${this.key}`)
        }
    )
  }

    handleViewRecipients = recipients => {
        this.setState(
            {
                recipients
            },
            () => {
                this.props.modal(`modal-view-recipients-${this.key}`)
            }
        )
    }

  render() {
    const {
      messages: { loading, list, offset, limit, pages, sort },
      permissions,
      setCommonLimit,
      intl,
      setMessagesParams
    } = this.props

    return (
      <div>
        <Table
          loading={loading}
          length={list.length}
          offset={offset}
          limit={limit}
          onSetLimit={setCommonLimit}
          pages={pages}
          sort={sort}
          setParams={setMessagesParams}
          ths={messagesLayout.tableHeaders()}
          permissions={permissions}
        >
          <Data>
            {list.map(({ id, groupId, notificationDeliveryType, content, title, hasActivityLog, createdAt, awardLeader, author, recipients }) => (
              <tr key={id}>
                <td>{id}</td>
                <td>{groupId}</td>
                <td>{hasActivityLog ?
                    intl.formatMessage({id: 'messages.praise',defaultMessage: 'Comment'}) :
                    intl.formatMessage({id: 'messages.message',defaultMessage: 'Message'})}
                </td>
                <td>{notificationDeliveryType === 'PUSH' ? 'NOTIFICATION' : notificationDeliveryType}</td>
                <td>
                  {createdAt ? (<FormattedDate value={createdAt} />) : "---"}
                </td>
                <td>
                    {get(author, 'awardLeader') ?
                        <Link to={{ pathname: `${config.publicPath}/leaders/${get(awardLeader, 'id')}/detail` }}>{get(author, 'fullname')}</Link> :
                        get(author, 'fullname')
                    }
                </td>
                <td>{title}</td>
                <td>
                  { content
                      ? <Button tertiary className="link" intlKey="button.view" onClick={() => this.handleViewMessage(content)} >View</Button>
                      : <FormattedMessage id="label.no_message" defaultMessage="No message" /> }
                </td>

                <td>
                    <span>({recipients.length}) </span>
                    { recipients && <Button tertiary className="link" intlKey="button.show_list" onClick={() => this.handleViewRecipients(recipients)} >Show list</Button>}
                    </td>
              </tr>
            ))}
          </Data>
        </Table>
        <Modal id={`modal-view-message-${this.key}`}>
          <ViewMessage message={this.state.message} />
        </Modal>
          <Modal id={`modal-view-recipients-${this.key}`} wider>
              <RecipientsTable recipients={this.state.recipients} />
          </Modal>
      </div>
    )
  }
}
